import apiClient from './index';
import {getLaunchPointUrl} from '../../src/api/ClientManagementService';

const version = 'v1';
const relativityEndpoint = (path: string) =>
  `/${version}/launchpoint/Relativity${path}`;

export interface PageInfo {
  filters: Array<{
    column: string;
    type: {
      type: string;
    };
    value: string;
    typeOperation: string;
  }>;
  sorts: Array<{
    column: string;
    direction: string | undefined | null;
  }>;
  page: number;
  pageSize: number;
}

type RelativityWorkspaceRequestBody = {
  filters: {
    column: string;
    type: string;
    value: string;
    typeOperation: string;
  }[];
  sorts: {
    column: string;
    direction: string;
  }[];
  page: number;
  pageSize: number;
};

// to fetch list of workspaces
export const getRelativityWorkspaces = (
  requestBody: RelativityWorkspaceRequestBody
) => {
  return apiClient.post(relativityEndpoint(`/workspaces`), {
    pageInfo: requestBody,
  });
};

export const launchWorkspace = async (
  instanceId: string,
  workspaceId: string
) => {
  const launchPointUrl = await getLaunchPointUrl(instanceId, workspaceId);
  const redirectUrl = launchPointUrl.data?.data;

  // open directly in a new tab
  window.open(redirectUrl, '_blank', 'noopener,noreferrer');
};
